import { ColumnDef } from '@tanstack/react-table';
import routes from '~/routes';
import { PlainLink } from 'components/link';
import { type TypeCurveScenarioRow } from './types';

export const typeCurveScenariosColumns: ColumnDef<TypeCurveScenarioRow>[] = [
  {
    accessorKey: 'name',
    header: 'Type Curve Scenario Name',
    size: 250,
    enableSorting: true,
    cell: ({ row, getValue }) => (
      <PlainLink
        href={`${routes.typeCurveScenariosPath}/${row.original.id}`}
        onClick={(e) => e.stopPropagation()}
      >
        {getValue() as string}
      </PlainLink>
    ),
  },
  {
    accessorKey: 'basin_area_count',
    header: 'Basin Area Count',
    size: 160,
    enableSorting: true,
    meta: { align: 'left', type: 'integer' },
  },
  {
    accessorKey: 'development_type',
    header: 'Development Type',
    size: 160,
    enableSorting: true,
    meta: { type: 'enum' },
    cell: ({ getValue }) => {
      const v = getValue() as string | undefined;
      if (!v) return '—';
      return (
        {
          ALL: 'All',
          HORIZONTAL: 'Horizontal',
          VERTICAL: 'Vertical',
        }[v.toUpperCase()] ?? v
      );
    },
  },
  {
    accessorKey: 'dca_scenario_name',
    header: 'DCA Scenario',
    size: 160,
    enableSorting: true,
    meta: { type: 'enum' },
    cell: ({ row, getValue }) => {
      const name = getValue() as string | null;
      if (!name) return '—';
      const dcaId = row.original.dca_scenario_id;
      if (dcaId === null || dcaId === undefined) return name;
      return (
        <PlainLink
          href={`${routes.dcaScenariosPath}/${dcaId}`}
          onClick={(e) => e.stopPropagation()}
        >
          {name}
        </PlainLink>
      );
    },
  },
  {
    accessorKey: 'created_by',
    id: 'createdBy',
    header: 'Created By',
    size: 150,
    enableSorting: true,
    meta: { type: 'enum' },
  },
  {
    accessorKey: 'created_at',
    id: 'createdAt',
    header: 'Created At',
    size: 150,
    enableSorting: true,
    meta: { type: 'date' },
  },
  {
    accessorKey: 'updated_at',
    id: 'updatedAt',
    header: 'Updated At',
    size: 150,
    enableSorting: true,
    meta: { type: 'date' },
  },
  {
    accessorKey: 'updated_by',
    header: 'Updated By',
    size: 150,
    enableSorting: true,
    meta: { type: 'text' },
  },
];
